import { render, staticRenderFns } from "./_templateBackground.vue?vue&type=template&id=ea0d4f24"
import script from "./_templateBackground.vue?vue&type=script&lang=js"
export * from "./_templateBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports